const CategorySEOText = function() {
    function CategorySEOText() {
        this.selector = {
            main: document.querySelector('.collection-category-text-wrapper')
        }
        this.load();
    }
    CategorySEOText.prototype.load = function() {
        var _ = this;
        if(_.selector.main) {
            _.selector.main.addEventListener('click', event => {
                console.log(event.target.closest('.toggle-see-more'));
                if(event.target.closest('.toggle-see-more') && event.target.closest('.toggle-see-more').classList.contains('active')) {
                    event.target.closest('.collection-category-text-wrapper').classList.add('see-more');
                    event.target.closest('.collection-category-text-wrapper').classList.remove('see-less');
                    event.target.closest('.collection-category-text-wrapper').querySelector('.toggle-see-less').classList.add('active');
                    event.target.closest('.toggle-see-more').classList.remove('active');
                } 
                if(event.target.closest('.toggle-see-less') && event.target.closest('.toggle-see-less').classList.contains('active')) {
                    event.target.closest('.collection-category-text-wrapper').classList.add('see-less');
                    event.target.closest('.collection-category-text-wrapper').classList.remove('see-more');
                    event.target.closest('.collection-category-text-wrapper').querySelector('.toggle-see-more').classList.add('active');
                    event.target.closest('.toggle-see-less').classList.remove('active');
                } 
            })
        }
    }
    CategorySEOText = new CategorySEOText;
}
CategorySEOText();